/**
 * Copyright Mántum All Rights Reserved.
 */
import type { Theme } from '@mantum/kanela';

export default function (theme: Theme = 'Ocean') {
    const themes = {
        Lemon: 'bg-gradient-to-r from-lime-500 to-green-500',
        Mountain: 'bg-gradient-to-r from-teal-500 to-emerald-500',
        Ocean: 'bg-gradient-to-r from-cyan-500 to-blue-500',
        Summer: 'bg-gradient-to-r from-amber-500 to-orange-500'
    };
    return themes[theme] || themes.Ocean;
}
